export const SubjectColors: string[] = [
  'linear-gradient(264deg, #CD4CE5 0%, #7C3BC9 100%)',
  'linear-gradient(257deg, #3A7BD5 0%, #00D2FF 100%)',
  'linear-gradient(258deg, #FF9472 0%, #F2709C 100%)',
  'linear-gradient(99deg, #1CB07C 0%, #BEE87A 100%)',
  'linear-gradient(259deg, #EF4493 0%, #FF3967 100%)',
  'linear-gradient(281deg, #52D682 0%, #1CA2A5 100%)',
  'linear-gradient(259deg, #E9C938 0%, #FF7307 100%)',
];

export const TP_COLORS = {
  black: '#000000',
  white: '#fff',
  listItemGray: {
    light: '#F1F5F9',
    dark: '#36393e',
  },
  paperGray: {
    light: '#F9F9F9',
    dark: '#36393e',
    mediumDark: '#A9A9A9',
  },
  tutopiyaGreenMain: {
    light: '#01B8AF',
    dark: '#0CD6CD',
    dark2: '#019f97',
    darken: '#01A79F',
  },
  blue: {
    light: '#003768',
    dark: '#006C9C',
    medium: '#3498DB',
    lighter: '#94A3B8',
  },
  gray: {
    light: '#475569',
    dark: '#334155',
    darken: '#1E293B',
  },
  yellow: {
    light: '#FFAB00',
  },
  orange: {
    lighter: '#FFE9D5',
    light: '#FF5630',
    darken: '#E64A19',
  },
  green: {
    lighter: '#D3FCD2',
    light: '#22C55E',
  },
  purple: {
    light: '#E8E4FD',
    darken: '#7C3AED',
  },
  border: {
    color1: '#E2E8F0',
    color2: '#CBD5E1',
  },
  typo: {
    white: '#F8FAFC',
  },
};

export const SUBJECT_COLORS_DIVIDED = [
  { color1: '#7C3BC9', color2: '#CD4CE5' },
  { color1: '#00D2FF', color2: '#3A7BD5' },
  { color1: '#FF9472', color2: '#F2709C' },
  { color1: '#1CB07C', color2: '#BEE87A' },
  { color1: '#EF4493', color2: '#FF3967' },
  { color1: '#52D682', color2: '#1CA2A5' },
  { color1: '#FF7307', color2: '#E9C938' },
];

export const SUBJECT_COLORS_NEW = {
  Mathematics: '#1C9FF7',
  Biology: '#109756',
  Chemistry: '#E67E22',
  Physics: '#9B59B6',
  CoordinatedScience: '#133A50',
  Economics: '#D44545',
  BusinessStudies: '#B462FF',
  EnglishLanguage: '#1C9FF7',
  EnglishLiterature: '#0B378C',
  AdditionalMathematics: '#A45E48',
  ComputerScience: '#FF69B4',
  CombinedScience: '#D89A21',
  Science: '#971071',
  Chinese: '#AC244D',
  Other: TP_COLORS.tutopiyaGreenMain.light,
};

export const GRADIENT_COLORS = {
  color1: 'linear-gradient(90deg, #DB86F8 0%, #006FD6 100%)',
};
